export default "__VITE_ASSET__BYYzdcQS__"